import { render, staticRenderFns } from "./ExportStock.vue?vue&type=template&id=488922c6&"
import script from "./ExportStock.vue?vue&type=script&lang=js&"
export * from "./ExportStock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports